/*! Copyright (c) Safe As Milk. All rights reserved. */
class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.mainDetailsToggle = this.querySelector("details") || this;
        this.trigger = this.querySelector("button, summary");
        this.content = this.querySelector(".nav__sub, .nav__sub-t, details-content, [role='menu']");

        if (this.trigger) {
            this.trigger.addEventListener("click", (e) => {
                if (this.trigger.tagName.toLowerCase() === "button") {
                    e.preventDefault();
                    if (this.isOpen) {
                        this.close();
                    } else {
                        this.open();
                    }
                }
            });
        }

        this.addEventListener("focusout", this.onFocusOut.bind(this));
        this.addEventListener("keydown", this.onKeyDown.bind(this));
        if (this.mainDetailsToggle.tagName && this.mainDetailsToggle.tagName.toLowerCase() === "details") {
            this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
        }
    }
    get isOpen() {
        if (this.trigger && this.trigger.hasAttribute("aria-expanded")) {
            return this.trigger.getAttribute("aria-expanded") === "true";
        }
        return this.hasAttribute("open") || (this.mainDetailsToggle && this.mainDetailsToggle.hasAttribute && this.mainDetailsToggle.hasAttribute("open"));
    }
    onFocusOut() {
        setTimeout((() => {
            if (!this.contains(document.activeElement)) this.close();
        }));
    }
    onToggle() {
        if (!this.content) return;
        if (!this.animations) this.animations = this.content.getAnimations();
        if (this.isOpen) {
            this.animations.forEach((animation => animation.play()));
        } else {
            this.animations.forEach((animation => animation.cancel()));
        }
    }
    onKeyDown(event) {
        if (event.key === "Escape") {
            if (this.isOpen) {
                this.close();
                if (this.trigger) this.trigger.focus();
                event.preventDefault();
                event.stopPropagation();
            }
        } else if ((event.key === "Enter" || event.key === " " || event.key === "ArrowDown") && (document.activeElement === this.trigger || this.contains(document.activeElement))) {
            if (document.activeElement === this.trigger) {
                event.preventDefault();
                if (!this.isOpen) {
                    this.open();
                } else if (event.key === "Enter" || event.key === " ") {
                    this.close();
                    return;
                }
                setTimeout(() => {
                    const firstFocusable = this.content ? this.content.querySelector("a, button, [role='menuitem']") : null;
                    if (firstFocusable) firstFocusable.focus();
                }, 50);
            }
        }
    }
    open() {
        this.setAttribute("open", "");
        this.classList.add("is-open");
        if (this.mainDetailsToggle && this.mainDetailsToggle.tagName && this.mainDetailsToggle.tagName.toLowerCase() === "details") {
            this.mainDetailsToggle.setAttribute("open", "");
        }
        if (this.trigger) {
            this.trigger.setAttribute("aria-expanded", "true");
        }
        this.onToggle();
    }
    close() {
        this.removeAttribute("open");
        this.classList.remove("is-open");
        if (this.mainDetailsToggle && this.mainDetailsToggle.tagName && this.mainDetailsToggle.tagName.toLowerCase() === "details") {
            this.mainDetailsToggle.removeAttribute("open");
        }
        if (this.trigger) {
            this.trigger.setAttribute("aria-expanded", "false");
        }
        this.onToggle();
    }
}

customElements.define("details-disclosure", DetailsDisclosure);

export default DetailsDisclosure;
//# sourceMappingURL=details-disclosure.js.map
